<div class="grid-container">
  <div class="overlay-sidebar" [class.active]="isSidebarOpen || isUserMenuOpen" [class.gray]="isSidebarOpen" (click)="CloseAllMenus()"></div>
  <!---========== Sidebar ==========--->
  <aside class="sidebar" id="sidebar-admin" [class.SeeToogle]="isSidebarOpen">
    <div class="top">
      <div class="logo">
        <img src="./assets/Global/Icon_SINCO.png" alt="" style="width: 40px; height: 40px;"/>
      </div>
      <a routerLink="/Dashboard/General/HomeSystemCDMS" class="title"> <span>Librerías</span> </a>
      <div class="close-sidebar" (click)="ActiveSideBar()">
        <i class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <ul>
      <!-- <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/DashboardAdmin/contributionCDMS">
          <span class="icon"><i class="fas fa-chart-area"></i></span>
          <span class="title">Contrib. Totales CDMS</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/DashboardAdmin/contrTotalCCP">
          <span class="icon"><i class="fas fa-chart-line"></i></span>
          <span class="title">Contrib. Totales HOE</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/DashboardAdmin/contrTotalISO">
          <span class="icon"><i class="fas fa-chart-line"></i></span>
          <span class="title">Contrib. Totales ISO</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/DashboardAdmin/contributionAP">
          <span class="icon"><i class="fas fa-chart-area"></i></span>
          <span class="title">Contrib. Totales AP</span>
        </a>
      </li> -->
      <li *ngFor="let reportLib of ReportLibraries" class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }" [hidden]="!UserService.UserRoleGeneralIn(reportLib.roles)">
        <a [routerLink]="['/DashboardAdmin/contrTotal', reportLib.slug]">
          <span class="icon"><i class="fas fa-chart-line"></i></span>
          <span class="title">Contrib. {{ reportLib.name }}</span>
        </a>
      </li>
      <li class="list" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }">
        <a routerLink="/DashboardAdmin/systemVisits">
          <span class="icon"><i class="fa-solid fa-users-rectangle"></i></span>
          <span class="title">Visitas del Sistema</span>
        </a>
      </li>
    </ul>
    <div class="Bottom">
      <li class="list" [routerLinkActive]="'active'">
        <a routerLink="/Dashboard/Admin/DAdministrator">
          <span class="icon"><i class="fas fa-angle-double-left"></i></span>
          <span class="title">Regresar inicio</span>
        </a>
      </li>
    </div>
  </aside>

  <!---========== Main ==========--->
  <main class="main-container">
    <nav class="navbar">
      <div class="left-nav">
        <div (click)="ActiveSideBar()" class="bars">
          <i class="fa-solid fa-bars"></i>
        </div>
        <!-- <div class="search inputText">
            <i class="fa-solid fa-magnifying-glass"></i><input type="text" placeholder="Buscar">
          </div> -->
      </div>
      <div class="right-nav">
        <!-- <div class="notifications button-square Drop_Lenguage">
            <p-select [options]="translate.getLangs()" [(ngModel)]="Selected"
              (onChange)="switchLang(Selected)"></p-select>
            <span class="number-circle"><i class="fa-solid fa-earth-americas"></i></span>
          </div> -->

        <!-- <div class="notifications button-square">
            <i class="far fa-bell"></i>
            <span class="number-circle">5</span>
          </div> -->
        <!-- <div class="mails button-square">
            <i class="far fa-envelope"></i>
            <span class="number-circle">8</span>
          </div> -->
        <div (click)="ToggleMenuUser(); $event.stopPropagation()" class="user">
          <!-- <div class="admin">
            <i class="fas fa-user-shield"></i>
          </div> -->
          <div class="name-user">
            {{ NameUser() }}
          </div>
          <div class="img">
            <img src="./assets/Global/Icon_user.png" alt="" />
          </div>
          <span class="arrow"><i class="fa-solid fa-angle-down"></i></span>
          <div (mouseleave)="ActiveMenuUser(false)" class="menu-side" [class.ShowMenuUser]="isUserMenuOpen" id="ShowMenuUser-admin">
            <ul>
              <li routerLink="/Dashboard/General/SeeAllTaskCDMS" class="item-user">
                <i class="fa-solid fa-list-check"></i><span class="item-user-text">Tareas</span>
              </li>
              <li (click)="CloseSession()" class="item-user">
                <i class="fa-solid fa-right-from-bracket"></i><span class="item-user-text">Cerrar sesión</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <section class="container-global">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global active" id="Loader" *ngIf="isLoadingLogout">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>